import { useContext } from 'react';
import { HotsauceContext } from '@providers/hotsauceContext';
import type { InterpolateFn } from '@utils/interpolate';

export function useInterpolate(): InterpolateFn {
  const context = useContext(HotsauceContext);

  if (!context) {
    throw new Error(
      '`useInterpolate` must be used within a `HotsauceProvider`',
    );
  }

  return context.interpolate;
}
